import React from "react";
import { Checkbox } from 'antd';
import PropTypes from 'prop-types';
function URCheckBoxCall(props: any) {
  let {name, onChange, checked, className, ...restProps } = props;
  return (
    <>
      <Checkbox name={name} className={className}
        onChange={props.onChange} {...restProps} checked={ props.checked}></Checkbox>
    </>

  );
}

export {
  URCheckBoxCall
};

URCheckBoxCall.propTypes = {
  onChange: PropTypes.any,
  className: PropTypes.any,
  name: PropTypes.any,
  checked: PropTypes.bool
};